import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Functions } from '@hub/common/Functions';
import { MenuService } from '@hub/components/v1/header';
import { eGridArea, eModules, eSystemModule, eUserPermissionLevel } from '@hub/generated/enums';
import { UserRoleSystemModuleDto } from '@hub/generated/models';
import { MenuItem } from '@hub/models/MenuItem';
import { CurrentUserService } from '@hub/services/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-grid-header-redirect',
	templateUrl: './grid-header-redirect.component.html'
})
export class GridHeaderRedirectComponent implements OnInit, OnDestroy {
	constructor(
		protected menuService: MenuService,
		private router: Router,
		private currentUser: CurrentUserService,
	) {

	}

	private _gridArea = eGridArea.Not_Set;
	@Input() set gridArea(area: eGridArea) {
		this._gridArea = area;
		this.menuItems = this.getMenuItems();
	}
	get gridArea() {
		return this._gridArea;
	}
	moduleName: string = "";
	public showMenu: boolean;
	menuItems: MenuItem[];
	userRoleSystemModules: UserRoleSystemModuleDto[] = [];
	private ngUnsubscribe: Subject<void> = new Subject<void>();

	ngOnInit(): void {
		this.currentUser.UserSystemModules
		.pipe(takeUntil(this.ngUnsubscribe))
		.subscribe(modules => {
			this.userRoleSystemModules = modules;
		})

		this.menuItems = this.getMenuItems();
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	getMenuItems(): MenuItem[] {
		switch (Number(this.gridArea)) {
			//case eGridArea.Tv10Booking:
			//	this.moduleName != "" ? "" : this.moduleName = Functions.getEnumName(eModules, eModules.Tv10Bookings, false).toLowerCase();
			case eGridArea.TvPackageBooking:
			case eGridArea.TvPackagePackage:
			case eGridArea.TvPackagePreCrm:
				this.moduleName != "" ? "" : this.moduleName = Functions.getEnumName(eModules, eModules.Packages, false).toLowerCase();
				let items: MenuItem[] = [];

				if (this.userRoleSystemModules.some(m => m.SystemModuleId === eSystemModule.HUBTvPackages_TvPackages && m.UserPermissionLevelFlag >= eUserPermissionLevel.Read)) {
					items.push(new MenuItem('Packages', 'tv-icon', true, 40, true, [Functions.getEnumName(eModules, eModules.Packages, false).toLowerCase()]));
				}
				return items;
			default:
				return [];
		}
	}

	redirect(link: any) {
		this.router.navigateByUrl(`/` + link);
	}
}
